const testimonialData = [
  {
    _id: 1,
    username: "Tymer 999",
    imageUrl: "imm.jpg",
    testimony: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aperiam maxime totam voluptates ut voluptatem, amet doloribus animi odit, expedita ducimus quos alias labore vero accusamus velit? Quo, deserunt? Minus, voluptatum!",
  },
  {
    _id: 2,
    username: "Donyina Gabriel",
    imageUrl: "imm.jpg",
    testimony: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aperiam maxime totam voluptates ut voluptatem, amet doloribus animi odit, expedita ducimus quos alias labore vero accusamus velit? Quo, deserunt? Minus, voluptatum!",
  },
];

export default testimonialData;
